/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../common";
import type { SupplyUni, SupplyUniInterface } from "../../contracts/SupplyUni";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
    ],
    name: "Delete",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token0",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token1",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint24",
        name: "poolFee",
        type: "uint24",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token0",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token1",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint24",
        name: "poolFee",
        type: "uint24",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    inputs: [],
    name: "DEADLINE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token0",
        type: "address",
      },
      {
        internalType: "address",
        name: "token1",
        type: "address",
      },
      {
        internalType: "uint24",
        name: "poolFee",
        type: "uint24",
      },
    ],
    name: "addPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
    ],
    name: "collectAllFees",
    outputs: [
      {
        internalType: "uint256",
        name: "amount0",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount1",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        internalType: "uint128",
        name: "percentageAmm",
        type: "uint128",
      },
      {
        internalType: "uint256",
        name: "maxSlip",
        type: "uint256",
      },
    ],
    name: "decreasePosition",
    outputs: [
      {
        internalType: "uint256",
        name: "amount0",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount1",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "deposits",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint128",
        name: "liquidity",
        type: "uint128",
      },
      {
        internalType: "uint256",
        name: "amount0",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount1",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "initialized",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
    ],
    name: "getOwnerInfo",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "uint128",
            name: "liquidity",
            type: "uint128",
          },
          {
            internalType: "uint256",
            name: "amount0",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "amount1",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "initialized",
            type: "bool",
          },
        ],
        internalType: "struct SupplyUni.OwnerDeposit",
        name: "deposit",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
    ],
    name: "getPool",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token0",
            type: "address",
          },
          {
            internalType: "address",
            name: "token1",
            type: "address",
          },
          {
            internalType: "uint24",
            name: "poolFee",
            type: "uint24",
          },
          {
            internalType: "bool",
            name: "isActive",
            type: "bool",
          },
        ],
        internalType: "struct SupplyUni.Pool",
        name: "pool",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountAdd0",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountAdd1",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxSlip",
        type: "uint256",
      },
    ],
    name: "increasePosition",
    outputs: [
      {
        internalType: "uint128",
        name: "liquidity",
        type: "uint128",
      },
      {
        internalType: "uint256",
        name: "amount0",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount1",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amm0",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amm1",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxSlip",
        type: "uint256",
      },
    ],
    name: "mintNewPosition",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint128",
        name: "liquidity",
        type: "uint128",
      },
      {
        internalType: "uint256",
        name: "amount0",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount1",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "nonfungiblePositionManager",
    outputs: [
      {
        internalType: "contract INonfungiblePositionManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "poolCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "pools",
    outputs: [
      {
        internalType: "address",
        name: "token0",
        type: "address",
      },
      {
        internalType: "address",
        name: "token1",
        type: "address",
      },
      {
        internalType: "uint24",
        name: "poolFee",
        type: "uint24",
      },
      {
        internalType: "bool",
        name: "isActive",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
    ],
    name: "retrieveNFT",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type SupplyUniConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SupplyUniConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SupplyUni__factory extends ContractFactory {
  constructor(...args: SupplyUniConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<SupplyUni> {
    return super.deploy(overrides || {}) as Promise<SupplyUni>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): SupplyUni {
    return super.attach(address) as SupplyUni;
  }
  override connect(signer: Signer): SupplyUni__factory {
    return super.connect(signer) as SupplyUni__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SupplyUniInterface {
    return new utils.Interface(_abi) as SupplyUniInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SupplyUni {
    return new Contract(address, _abi, signerOrProvider) as SupplyUni;
  }
}
